// extracted by mini-css-extract-plugin
module.exports = {"SearchChips":"_3SH38S9d","chipsContainer":"w_zAalAj","chipsHolder":"_3ELSkNSe","chipsLabel":"_1cj9_Jg6"};
    if(module.hot) {
      // 1754514966212
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  